import type { ApiCaseNote } from './apiTypes';
import type { CaseNote } from './types';

export function convertToCaseNote(caseNoteResponseObject: ApiCaseNote): CaseNote {
  return {
    noteId: caseNoteResponseObject.note_id,
    caseId: caseNoteResponseObject.case_id,
    userId: caseNoteResponseObject.user_id,
    createDate: caseNoteResponseObject.create_date,
    lastModified: caseNoteResponseObject.last_modified ?? null,
    note: caseNoteResponseObject.note,
  };
}

export function isOrgManagerOrHigher(accessLevel?: string | null): boolean {
  return accessLevel === 'OrgManager' || accessLevel === 'Sales' || accessLevel === 'SysAdmin';
}

export function canModifyCaseNote(note: CaseNote, currentUserId?: number, accessLevel?: string | null): boolean {
  const isAuthor = currentUserId != null && note.userId === currentUserId;
  return isAuthor || isOrgManagerOrHigher(accessLevel);
}
